import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { Domain, DOMAINS } from '../auth/user-access.model';
import { ConfigService } from '../config/config.service';
import { APP_VERSION } from './app-version';
import { targetEnvironmentFor } from './target-environments';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private readonly environmentName = inject(ConfigService).getEnv('name');
  private readonly router = inject(Router);
  private readonly activeDomain = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.currentDomain()),
    ),
    { initialValue: this.currentDomain() },
  );
  readonly targetEnvironment = computed(() =>
    targetEnvironmentFor(this.environmentName, this.activeDomain()),
  );

  readonly environmentLabel = computed(() => this.targetEnvironment().toUpperCase());

  readonly isNonProductionTarget = computed(() => this.targetEnvironment() !== 'prod');

  version = computed(() => {
    return APP_VERSION;
  });

  private currentDomain(): Domain | undefined {
    let route = this.router.routerState.snapshot.root;
    let domain: Domain | undefined;
    while (true) {
      const routeDomain = DOMAINS.find((value) => value === route.data['environmentDomain']);
      domain = routeDomain ?? domain;
      if (!route.firstChild) {
        return domain;
      }
      route = route.firstChild;
    }
  }
}
